import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import App from './App.vue'

window.addEventListener('DOMContentLoaded',function(){

    let orderInfoApps = document.querySelectorAll(".order-info-app");
    for (let appContainer of orderInfoApps) {
        new Vue({
            el: appContainer,
            data: {
                prodid: appContainer.dataset.prodid,
                model: appContainer.dataset.model,
                type: appContainer.dataset.type,
                guid: appContainer.dataset.guid
            },
            components: { App },
            template: "<App/>"
        });
    }
});
